import { FC, ChangeEvent, useState, useEffect } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { useSelector } from 'react-redux'

import { utils } from '../../../utils'
import { Layout } from '../../../containers'
import { Loading, Select, Title } from '../../../components/UI'
import { ProfileDelete, ProfileForm, ProfilePasswordForm, ProfileView } from '../../../components'
import { useAuth, useProfile } from '../../../hooks'
import avatarDefaultImg from '../../../assets/img/avatar-default.jpg'

const tabClass = 'react-tabs__tab react-tabs_col-4'

const ProfilePage:FC = () => {
  const userCurrent = useAuth()
  const useUser = useProfile()
  const [userAvatar, setUserAvatar] = useState<string>('')
  const profilePasswordChangeSw = useSelector((state: any) => state.profilePasswordChangeSw)
  const [tabIndex, setTabIndex] = useState<number>(0)

  useEffect(() => {
    setTabIndexDefault()
    setUserPhoto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getForgotPasswordSw = () => {
    const userInfo = userCurrent.getInfo()
    return (profilePasswordChangeSw)
  }

  const forgotPasswordSw: boolean = getForgotPasswordSw()

  const setTabIndexDefault = () => {
    setTabIndex((forgotPasswordSw ? 2 : 0))
  }

  const setUserPhoto = async () => {
    const uAvatar: string = await useUser.getUserAvatar(avatarDefaultImg)
    setUserAvatar(uAvatar)
  }

  const onTabSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { target: { value } } = event
    setTabIndex(Number(value))
  }

  const onProfileChange = () => {
    useUser.getUserCurrent()
    setUserPhoto()
  }

  return (
    <Layout menu titleMain={1}>

      <Title border>Perfil</Title>

      <Select
        name="tabOptions"
        sizes="md"
        color="primary"
        value={tabIndex}
        fullWidth
        className="lg:d-none mt-50"
        onChange={onTabSelectChange}
      >
        <option value="0">Mis datos</option>
        <option value="1">Cambiar datos</option>
        <option value="2">Cambiar contraseña</option>
        <option value="3">Eliminar perfil</option>
      </Select>

      <Tabs
        selectedIndex={tabIndex}
        className="lg:mt-40"
        onSelect={index => setTabIndex(index)}
      >
        <TabList>
          <Tab className={tabClass}>Mis datos</Tab>
          <Tab className={tabClass}>Cambiar datos</Tab>
          <Tab className={tabClass}>Cambiar contraseña</Tab>
          <Tab className={tabClass}>Eliminar perfil</Tab>
        </TabList>

        <TabPanel>
          <ProfileView
            user={useUser.user}
            userAvatar={userAvatar}
            className="py-50 lg:px-50"
          />
        </TabPanel>
        <TabPanel>
          {!utils.isObjectEmpty(useUser.user) ?
              <ProfileForm
                user={useUser.user}
                userAvatar={userAvatar}
                onChange={onProfileChange}
                className="py-50 lg:px-50"
              />
            :
              <div className="py-50 lg:px-50">
                <Loading align="center" />
              </div>
          }
        </TabPanel>
        <TabPanel>
          <ProfilePasswordForm forgotPasswordSw={forgotPasswordSw} className="py-50 lg:px-70" />
        </TabPanel>
        <TabPanel>
          <ProfileDelete className="text-center py-50 lg:py-100 mx-auto" style={{ maxWidth: 370 }} />
        </TabPanel>
      </Tabs>
    </Layout>
  )
}

export { ProfilePage }